import { PostDisplay } from '$types';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { EuroPipe } from '$pipes/euro.pipe';

@Component({
  selector: 'app-secondary-info',
  templateUrl: './secondary-info.component.html',
  styleUrls: ['./secondary-info.component.css']
})
export class SecondaryInfoComponent {
  @Input() post!: PostDisplay;

}
